/**
 * Pulsar Money Campaign Configuration
 */

export const CAMPAIGN_ID = "yiedl";
export const CAMPAIGN_GROUP_ID = "1";

export const CAMPAIGN_CONFIG = {
  id: CAMPAIGN_ID,
  groupId: CAMPAIGN_GROUP_ID,
} as const;
